export { default } from './svg/stub-default.svg';
